<template>
  <div class="container">
    <img src="static/img/topevent.png" alt="">
    <div class="icondiv">
      <img src="static/img/02.png" class="icon" alt="">
    </div>
    <h3>我的许愿</h3>
    <van-list
      v-model="listloading"
      :finished="listfinished"
      :immediate-check="false"
      finished-text="没有更多啦"
      @load="listload_more"
    >
      <div class="maindiv" v-for="item in list" :key="item.id" @click="urlchange(item.id)">
        <div class="left">
          <p>许愿时间：{{item.createtime}}</p>
          <p>许愿内容：{{item.content}}</p>
          <p>所在地区：江阴市-{{item.street_str}}-{{item.village_str}}</p>
          <p>审核状态：{{item.state_str}}</p>
        </div>
        <div class="bt" v-show="item.state == 4 && !item.star" @click.stop="linkto(item.id,item.star)">点评</div>
        <div class="btrated" v-show="item.state == 4 && item.star">已点评</div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name:'mywish',
  data() {
    return{
      list:[],
      listloading:false,
      listfinished:false,
      listpage:1,
    }
  },
  created(){
    this.init();
  },
  methods:{
    urlchange(id){
      this.$router.push({
        name:'wishcheck',
        query:{
          id:id,
        }
      })
    },
    linkto(id,star){
      if(star>0){
        this.$toast('您已点评过此条');
        return;
      }
      this.$router.push({
        name:'wishrate',
        query:{
          id:id,
        }
      })
    },
    init(){
      this.$axios({
        method:'post',
        url:'/api/task/my_wish',
        data:this.qs.stringify({
          zjy_uid:sessionStorage.getItem('uid')
        })
      }).then(res => {
        console.log(res.data);
        this.list = res.data.data.list;
      })
    },
    listload_more(){
      this.listpage += 1;
      var that = this;
      setTimeout(function(){
        that.$axios({
          method:'post',
          url:'/api/task/my_wish',
          data:that.qs.stringify({
            zjy_uid:sessionStorage.getItem('uid'),
            page:that.listpage,
          })
        }).then(res => {
          console.log(res.data);
          that.list = that.list.concat(res.data.data.list);
          that.listloading = false;
          if (res.data.data.list.length == 0) {  //数据全部加载完成
            that.listfinished = true;
          }else{
            that.listfinished = false;
          }
        })
      },500)
    }
  }
}
</script>
<style scoped>
img{
  width: 100%;
  display: block;
}
.icondiv{
  width: 15vw;
  height: 15vw;
  border-radius: 50%;
  background: #EDD9AD;
  display: flex;
  position: absolute;
  top: 15vw;
  left: 5vw;
}
.icon{
  width: 60%;
  height: 60%;
  margin: auto;
}
h3{
  color: white;
  position: absolute;
  top: 20vw;
  right: 5vw;
}
.maindiv{
  background: #FFFAF7;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0px 2px 6px 0px rgba(155, 150, 113, 38);
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
  border-top: 5px solid #FD9292;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bt{
  color: white;
  background: #E04848;
  font-weight: bold;
  padding: 15px 10px;
  padding-bottom: 5px;
  border-radius: 5px;
  writing-mode: vertical-lr;
  letter-spacing: 10px;
}
.btrated{
  color: #E04848;
  border: 1px solid #E04848;
  font-weight: bold;
  padding: 10px;
  padding-bottom: 5px;
  border-radius: 5px;
  writing-mode: vertical-lr;
  letter-spacing: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/mywish.vue